var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SideBar',{attrs:{"visible":_vm.isExtraGuaranteeOpen}},[_c('ExtraGuaranteeInner',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.extraGuaranteeClickOutside),expression:"extraGuaranteeClickOutside"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }